import type { Tier, TenantStatus, JobStatus, WorkspaceStatus } from '@/data/types';

// Plans are data (MC-611): these maps only cover the four seeded plans.
// Always go through tierLabel()/tierTone() so custom plans degrade to
// their slug + neutral tone. Limits come from the API (usePlans /
// useTenantPlan) — the old hardcoded TIER_LIMITS copy is gone.
export const TIER_LABEL: Record<string, string> = {
  starter: 'Starter',
  team: 'Team',
  business: 'Business',
  enterprise: 'Enterprise',
};

export const TIER_TONE: Record<string, 'neutral' | 'accent' | 'success' | 'warn'> = {
  starter: 'neutral',
  team: 'accent',
  business: 'success',
  enterprise: 'warn',
};

export function tierLabel(tier: Tier): string {
  return TIER_LABEL[tier] ?? tier;
}

export function tierTone(tier: Tier): 'neutral' | 'accent' | 'success' | 'warn' {
  return TIER_TONE[tier] ?? 'neutral';
}

export const SIZE_ORDER = [
  'shared', 's-1vcpu-2gb', 's-2vcpu-4gb', 's-4vcpu-8gb',
  's-8vcpu-16gb', 's-16vcpu-32gb', 'byo',
];

export const REGION_LABEL: Record<string, string> = {
  lon1: 'London',
  fra1: 'Frankfurt',
  nyc3: 'New York',
};

export const TENANT_STATUS_LABEL: Record<TenantStatus, string> = {
  active: 'Active',
  trialing: 'Trial',
  past_due: 'Past due',
  suspended: 'Suspended',
  churned: 'Churned',
};

export const TENANT_STATUS_TONE: Record<TenantStatus, 'neutral' | 'accent' | 'success' | 'warn' | 'danger'> = {
  active: 'success',
  trialing: 'accent',
  past_due: 'warn',
  suspended: 'danger',
  churned: 'neutral',
};

export const JOB_STATUS_LABEL: Record<JobStatus, string> = {
  pending: 'Pending',
  reserving_infra: 'Reserving infra',
  allocating: 'Allocating',
  installing: 'Installing',
  migrating: 'Migrating',
  smoke_test: 'Smoke test',
  live: 'Live',
  failed: 'Failed',
};

export const JOB_STATUS_TONE: Record<JobStatus, 'neutral' | 'accent' | 'success' | 'warn' | 'danger'> = {
  pending: 'neutral',
  reserving_infra: 'accent',
  allocating: 'accent',
  installing: 'accent',
  migrating: 'accent',
  smoke_test: 'accent',
  live: 'success',
  failed: 'danger',
};

export const WORKSPACE_STATUS_TONE: Record<WorkspaceStatus, 'neutral' | 'accent' | 'success' | 'warn' | 'danger'> = {
  live: 'success',
  provisioning: 'accent',
  degraded: 'warn',
  suspended: 'warn',
  error: 'danger',
  idle: 'neutral',
};

export const RISK_FLAG_LABEL: Record<string, string> = {
  churn_risk: 'Churn risk',
  expansion_candidate: 'Expansion',
  overage: 'Overage',
  failed_payment: 'Payment failed',
};

export const RISK_FLAG_TONE: Record<string, 'neutral' | 'accent' | 'success' | 'warn' | 'danger'> = {
  churn_risk: 'warn',
  expansion_candidate: 'accent',
  overage: 'warn',
  failed_payment: 'danger',
};
